import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import { DatabaseService } from '../database.service';


declare var jQuery: any;
@Component({
    selector: 'app-collections',
    templateUrl: './collections.component.html',
    styleUrls: ['./collections.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('fadeAndZoom', [
            state('inactive', style({
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            state('active', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
            transition('active => inactive', animate('100ms ease-out'))
        ])
    ]
})



export class CollectionsComponent implements OnInit {


    constructor(
        private database: DatabaseService
    ) { }


    ngOnInit(){
        
    }


}



// WEBPACK FOOTER //
// ./src/app/collections/collections.component.ts